module.exports = __webpack_public_path__ + "img/apple_podcast_logo.ff34ff12.png";